import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"background":"none","border":"none","padding":"0","color":"white"},
  type: "button",
  "aria-label": "Toggle menu"
}
const _hoisted_2 = { class: "ml-2 align-middle font-weight-bold" }
const _hoisted_3 = { class: "ml-2 font-weight-bold" }
const _hoisted_4 = { class: "ml-2 align-middle font-weight-bold" }
const _hoisted_5 = {
  action: "",
  class: "w-50 mx-auto hd-search"
}
const _hoisted_6 = { class: "input-group ml-5" }
const _hoisted_7 = { class: "input-group-prepend" }
const _hoisted_8 = {
  class: "input-group-text bg-white",
  id: "basic-addon1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SearchView = _resolveComponent("SearchView")!
  const _component_HeaderSideMenuV1 = _resolveComponent("HeaderSideMenuV1")!
  const _component_UserAreaV1 = _resolveComponent("UserAreaV1")!
  const _component_BNavbar = _resolveComponent("BNavbar")!
  const _component_EditStyle = _resolveComponent("EditStyle")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_BNavbar, {
        class: "cd-menu",
        fixed: "top"
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", _hoisted_1, [
            _createVNode(_component_font_awesome_icon, {
              class: "cd-menu-toggle",
              icon: "bars",
              onClick: _ctx.toggle
            }, null, 8, ["onClick"])
          ]),
          (_ctx.cdOrganisationAvailable)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "cd-menu-branding",
                to: { name: 'Dashboard' },
                style: {"display":"flex","color":"white","text-decoration":"none"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.tenantName) + " / ", 1),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.pageName), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                class: "cd-menu-branding",
                to: { name: 'Dashboard' }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.pageName), 1)
                ]),
                _: 1
              })),
          _createElementVNode("form", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_component_font_awesome_icon, {
                    fixedWidth: true,
                    icon: ['fas', 'magnifying-glass'],
                    class: "searchIcon"
                  })
                ])
              ]),
              _withDirectives(_createElementVNode("input", {
                ref: "search",
                type: "text",
                class: "form-control",
                placeholder: "Search...",
                onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSearchBox())),
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideSearchBox($event.relatedTarget))),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchValue) = $event)),
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getSearchValue())),
                id: "search",
                "aria-label": "Search"
              }, null, 544), [
                [_vModelText, _ctx.searchValue]
              ])
            ]),
            (_ctx.showSearchView)
              ? (_openBlock(), _createBlock(_component_SearchView, {
                  key: 0,
                  showSearchView: _ctx.showSearchView,
                  stylesData: _ctx.stylesData,
                  searchedStylesData: _ctx.searchedStylesData,
                  onUpdateSearchView: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSearchView = false)),
                  onGetEditStyleId: _ctx.getEditStyleId,
                  onSetVisibleEdit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.visibleEdit = true))
                }, null, 8, ["showSearchView", "stylesData", "searchedStylesData", "onGetEditStyleId"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_HeaderSideMenuV1, {
            id: "menu-sidebar",
            visible: _ctx.isVisible,
            "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isVisible) = $event))
          }, null, 8, ["visible"]),
          _createVNode(_component_UserAreaV1)
        ]),
        _: 1
      })
    ]),
    (_ctx.visibleEdit)
      ? (_openBlock(), _createBlock(_component_EditStyle, {
          key: 0,
          visibleEdit: _ctx.visibleEdit,
          editStyleId: _ctx.editStyleId
        }, null, 8, ["visibleEdit", "editStyleId"]))
      : _createCommentVNode("", true)
  ]))
}